module.exports = __webpack_public_path__ + "img/tech-icon.61d23265.svg";